<div [ngStyle]="{'height': 'inherit', 'display':'flex', 'flex-direction':'column'}">
  <div class="dx-fieldset" [ngStyle]="{'margin': '20px 30px'}">
    <div class="dx-field">
      <div class="dx-field-label">{{ 'Featuressysteme auswählen' | translate }}</div>
      <div class="dx-field-value">
        <dx-switch [(value)]="exportParameter.featureSystemContentFilter.useFilter" (onValueChanged)="refreshFeatureSystemFilter()"></dx-switch>
      </div>
    </div>
  </div>
  <div *ngIf="exportParameter.featureSystemContentFilter.useFilter" [ngStyle]="{'height': '100%', 'overflow':'hidden'}">
    <div *ngIf="isFeatureSystemFiltersLoaded==false">
      <div class="loader">
      </div>
    </div>
    <div *ngIf="isFeatureSystemFiltersLoaded==true" class="{{fullScreen ? '' : 'maxHeight'}}" [ngStyle]="{'margin-top': '-20px', 'height': 'inherit'}">
      <dx-tree-list [(dataSource)]="featureSystemFilters"
                    [(selectedRowKeys)]="exportParameter.featureSystemContentFilter.filterKey"
                    dataStructure="tree"
                    itemsExpr="items"
                    keyExpr="groupString"
                    showCheckBoxesMode="selectAll"
                    [ngStyle]="{'height': 'inherit'}">
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="multiple" recursive="true"></dxo-selection>
        <dxo-scrolling preloadEnabled="true" useNative="true"></dxo-scrolling>
        <dxi-column dataField="text" caption="{{ 'FeatureSystems' | translate }}"></dxi-column>
      </dx-tree-list>
    </div>
  </div>
</div>
